import { useState, useEffect, useRef } from 'react';
import { getProdutosAdmin, criarProduto, atualizarProduto, uploadFotoProduto, removerFotoProduto, moverProduto } from '../../services/api';

const API_URL = process.env.REACT_APP_API_URL || '';
const EMOJIS = ['🍔','🍗','🌭','🥖','🍟','🧅','🥗','🍕','🥤','🧃','🥛','💧','☕','🍰','🧁','🎂'];
const defaultForm = { nome: '', descricao: '', preco: '', emoji: '🍔', categoria_id: 1, disponivel: true, destaque: false };

export default function AdminProdutos() {
  const [produtos, setProdutos] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [editId, setEditId] = useState(null);
  const [aba, setAba] = useState('lista');
  const [loading, setLoading] = useState(false);
  const [uploadingId, setUploadingId] = useState(null);
  const [busca, setBusca] = useState(false);
  const [toast, setToast] = useState('');
  const fotoRefs = useRef({});

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };
  const carregar = () => getProdutosAdmin().then(r => setProdutos(r.data)).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const salvar = async () => {
    if (!form.nome || !form.preco) return showToast('⚠️ Nome e preço obrigatórios');
    setLoading(true);
    try {
      const dados = { ...form, preco: parseFloat(form.preco) };
      editId ? await atualizarProduto(editId, dados) : await criarProduto(dados);
      showToast(editId ? '✅ Produto atualizado!' : '✅ Produto criado!');
      setForm(defaultForm); setEditId(null); setAba('lista'); carregar();
    } catch { showToast('❌ Erro ao salvar'); }
    finally { setLoading(false); }
  };

  const editar = (p) => {
    setForm({ nome: p.nome, descricao: p.descricao || '', preco: p.preco, emoji: p.emoji, categoria_id: p.categoria_id, disponivel: !!p.disponivel, destaque: !!p.destaque });
    setEditId(p.id); setAba('form');
  };

  const toggleDisponivel = async (p) => {
    await atualizarProduto(p.id, { ...p, disponivel: !p.disponivel });
    carregar();
  };

  const uploadFoto = async (id, file) => {
    if (!file) return;
    setUploadingId(id);
    const fd = new FormData(); fd.append('foto', file);
    try { await uploadFotoProduto(id, fd); showToast('✅ Foto atualizada!'); carregar(); }
    catch { showToast('❌ Erro ao enviar foto'); }
    finally { setUploadingId(null); }
  };

  const removerFoto = async (id) => {
    try { await removerFotoProduto(id); showToast('🗑️ Foto removida'); carregar(); }
    catch { showToast('❌ Erro ao remover'); }
  };

  const mover = async (id, direcao) => {
    try { await moverProduto(id, direcao); carregar(); }
    catch { showToast('❌ Erro ao mover'); }
  };

  const filtrados = busca ? produtos.filter(p => p.nome.toLowerCase().includes(busca.toLowerCase())) : produtos;

  return (
    <div style={{ padding: 16 }}>
      {toast && <div style={{ position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999 }}>{toast}</div>}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <h2 style={{ margin: 0 }}>🍔 Produtos</h2>
        <button className="btn-primary" style={{ width: 'auto', padding: '8px 16px', fontSize: 13 }}
          onClick={() => { setForm(defaultForm); setEditId(null); setAba('form'); }}>+ Novo</button>
      </div>

      {/* Abas */}
      <div style={{ display: 'flex', gap: 4, background: 'var(--bg3)', padding: 4, borderRadius: 8, marginBottom: 14 }}>
        {[['lista','📋 Lista'],['form', editId ? '✏️ Editar' : '➕ Novo']].map(([key, label]) => (
          <button key={key} onClick={() => setAba(key)} style={{
            flex: 1, background: aba === key ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'none',
            border: 'none', color: aba === key ? '#fff' : 'var(--text2)', padding: 8, borderRadius: 6,
            cursor: 'pointer', fontFamily: 'Nunito,sans-serif', fontWeight: 700, fontSize: 12
          }}>{label}</button>
        ))}
      </div>

      {/* LISTA */}
      {aba === 'lista' && (
        <>
          <input className="input-field" placeholder="🔍 Buscar produto..." value={busca || ''}
            onChange={e => setBusca(e.target.value)} style={{ marginBottom: 10 }} />
          <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>{filtrados.length} produto(s)</div>
          {filtrados.map(p => (
            <div key={p.id} className="card" style={{ padding: 12, opacity: p.disponivel ? 1 : 0.55 }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                {/* Foto */}
                <div style={{ position: 'relative', flexShrink: 0 }}>
                  <div style={{ width: 60, height: 60, borderRadius: 10, background: 'var(--bg4)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, overflow: 'hidden' }}>
                    {p.imagem_url ? <img src={`${API_URL}${p.imagem_url}`} alt={p.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : p.emoji}
                    {uploadingId === p.id && <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, color: '#fff' }}>...</div>}
                  </div>
                  <button onClick={() => fotoRefs.current[p.id]?.click()} style={{ position: 'absolute', bottom: -4, right: -4, width: 20, height: 20, borderRadius: '50%', background: 'var(--orange)', border: 'none', cursor: 'pointer', fontSize: 10 }}>📷</button>
                  <input ref={el => fotoRefs.current[p.id] = el} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => uploadFoto(p.id, e.target.files[0])} />
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 2 }}>{p.nome}</div>
                  <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 4, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{p.descricao}</div>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{ color: 'var(--orange)', fontWeight: 800, fontSize: 14 }}>R$ {parseFloat(p.preco).toFixed(2).replace('.', ',')}</span>
                    {p.destaque ? <span style={{ background: 'var(--red)', color: '#fff', fontSize: 9, fontWeight: 800, padding: '2px 5px', borderRadius: 4 }}>DESTAQUE</span> : null}
                    <span style={{ fontSize: 9, color: 'var(--text3)' }}>{p.categoria_nome}</span>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flexShrink: 0 }}>
                  <div style={{ display: 'flex', gap: 2 }}>
                    <button onClick={() => mover(p.id, 'cima')} title="Mover para cima" style={{ flex: 1, background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)', padding: '2px 4px', borderRadius: 5, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', lineHeight: 1 }}>▲</button>
                    <button onClick={() => mover(p.id, 'baixo')} title="Mover para baixo" style={{ flex: 1, background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)', padding: '2px 4px', borderRadius: 5, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', lineHeight: 1 }}>▼</button>
                  </div>
                  <button onClick={() => editar(p)} style={{ background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)', padding: '4px 8px', borderRadius: 5, cursor: 'pointer', fontSize: 11, fontFamily: 'Nunito,sans-serif' }}>✏️</button>
                  <button onClick={() => toggleDisponivel(p)} style={{ background: p.disponivel ? 'rgba(46,168,46,.15)' : 'rgba(230,48,48,.15)', border: `1px solid ${p.disponivel ? 'rgba(46,168,46,.3)' : 'rgba(230,48,48,.3)'}`, color: p.disponivel ? '#2ea82e' : 'var(--red)', padding: '4px 8px', borderRadius: 5, cursor: 'pointer', fontSize: 10, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>{p.disponivel ? 'ON' : 'OFF'}</button>
                  {p.imagem_url && <button onClick={() => removerFoto(p.id)} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text3)', padding: '4px 8px', borderRadius: 5, cursor: 'pointer', fontSize: 11 }}>🗑️</button>}
                </div>
              </div>
            </div>
          ))}
        </>
      )}

      {/* FORM */}
      {aba === 'form' && (
        <div className="card">
          <h3 style={{ marginBottom: 14 }}>{editId ? '✏️ Editar' : '➕ Novo produto'}</h3>
          <div className="input-group"><label className="input-label">Nome *</label><input className="input-field" placeholder="Ex: X-Burgão Roger" value={form.nome} onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} /></div>
          <div className="input-group"><label className="input-label">Descrição</label><textarea className="input-field" placeholder="Ingredientes..." value={form.descricao} onChange={e => setForm(p => ({ ...p, descricao: e.target.value }))} style={{ resize: 'vertical', minHeight: 60 }} /></div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div className="input-group"><label className="input-label">Preço (R$) *</label><input className="input-field" type="number" step="0.01" placeholder="0,00" value={form.preco} onChange={e => setForm(p => ({ ...p, preco: e.target.value }))} /></div>
            <div className="input-group"><label className="input-label">Categoria</label>
              <select className="input-field" value={form.categoria_id} onChange={e => setForm(p => ({ ...p, categoria_id: parseInt(e.target.value) }))} style={{ cursor: 'pointer' }}>
                <option value={1}>Destaques</option><option value={2}>Bebidas</option><option value={3}>Porções & Extras</option>
              </select>
            </div>
          </div>
          <div className="input-group">
            <label className="input-label">Emoji</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, padding: 8, background: 'var(--bg4)', borderRadius: 8 }}>
              {EMOJIS.map(em => <button key={em} onClick={() => setForm(p => ({ ...p, emoji: em }))} style={{ width: 36, height: 36, borderRadius: 8, border: `2px solid ${form.emoji === em ? 'var(--orange)' : 'transparent'}`, background: form.emoji === em ? 'rgba(255,107,0,.15)' : 'none', fontSize: 18, cursor: 'pointer' }}>{em}</button>)}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 16, marginBottom: 14 }}>
            {[['disponivel','✅ Disponível'],['destaque','🔥 Destaque']].map(([field, label]) => (
              <label key={field} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                <input type="checkbox" checked={!!form[field]} onChange={e => setForm(p => ({ ...p, [field]: e.target.checked }))} style={{ accentColor: 'var(--orange)', width: 16, height: 16 }} />{label}
              </label>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn-primary" onClick={salvar} disabled={loading} style={{ flex: 1 }}>{loading ? '⏳...' : editId ? '💾 Salvar' : '✅ Criar'}</button>
            <button className="btn-secondary" style={{ width: 'auto', padding: '12px 16px' }} onClick={() => { setForm(defaultForm); setEditId(null); setAba('lista'); }}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}
